import { render, staticRenderFns } from "./Seat.vue?vue&type=template&id=3aceae0b&scoped=true"
import script from "./Seat.vue?vue&type=script&lang=js"
export * from "./Seat.vue?vue&type=script&lang=js"
import style0 from "./Seat.vue?vue&type=style&index=0&id=3aceae0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aceae0b",
  null
  
)

export default component.exports